<template>
  <div class="page-vendor-search">
  <div class="mx-auto flex max-w-4xl flex-col gap-8 px-4 py-12 lg:px-8">
      <div class="flex items-center justify-between">
        <a class="text-sm font-semibold text-brand" href="/vendors">← Back to vendors</a>
        <p class="text-sm text-muted">Purpose-built vendor search</p>
      </div>
    
      <form class="space-y-4 rounded-3xl bg-white p-6 shadow-card ring-1 ring-gray-100">
        <div class="grid gap-4 md:grid-cols-2">
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Location</span>
            <input type="text" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="City or neighborhood" />
          </label>
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Category</span>
            <select class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink focus:border-brand focus:outline-none">
              <option>Any</option>
              <option>Planning</option>
              <option>Photography</option>
              <option>Videography</option>
              <option>Music</option>
              <option>Decor</option>
              <option>Catering</option>
            </select>
          </label>
        </div>
        <div class="grid gap-4 md:grid-cols-2">
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Budget</span>
            <input type="text" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="e.g., $2k - $6k" />
          </label>
          <label class="space-y-2 text-sm font-semibold text-ink">
            <span class="text-muted">Keywords</span>
            <input type="search" class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" placeholder="Film style, DJ, harp, etc." />
          </label>
        </div>
        <button type="button" class="w-full rounded-2xl bg-brand px-4 py-3 text-sm font-semibold text-white shadow-card transition hover:bg-brandDark">Search vendors</button>
      </form>
    </div>
  </div>
</template>

<script>
import { useSeoMeta } from '@/utils/seo'

export default {
  name: 'VendorSearchView',
  setup () {
    useSeoMeta({
      title: 'Search Event Vendors',
      description: 'Search event vendors by location, category, budget, and services to find the right professionals for your celebration.',
      path: '/vendor-search'
    })
  }
}
</script>
